export default "/_next/static/chunks/bust-2-d.d95909838adec5e7026ebd68e7318809.glb";